import React, { ImgHTMLAttributes } from 'react'

import { useUrlCloudfront } from 'hooks/useEnv'

const Img: React.FC<ImgHTMLAttributes<HTMLImageElement>> = (props) => {
  const { src, alt = '', className = '', height, width, ...rest } = props

  const urlCloudfront = useUrlCloudfront()

  if (!urlCloudfront) {
    return null
  }

  // Keep previous behavior: prefix with `/images`
  const resolvedSrc = `${urlCloudfront}/images${src}`

  return <img {...rest} src={resolvedSrc} alt={alt} className={className} height={height} width={width} />
}

export default Img
